import Icons, { SvgIconProps } from '@mui/joy/SvgIcon';

export default function (props: SvgIconProps) {
  return (
    <Icons {...props}>
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M16.6667 25.9583L25.9583 20L16.6667 14.0417V25.9583ZM20 35C17.9167 35 15.9656 34.6044 14.1467 33.8133C12.3267 33.0211 10.7433 31.9511 9.39667 30.6033C8.04889 29.2567 6.97889 27.6733 6.18667 25.8533C5.39556 24.0344 5 22.0833 5 20C5 17.9167 5.39556 15.965 6.18667 14.145C6.97889 12.3261 8.04889 10.7428 9.39667 9.395C10.7433 8.04833 12.3267 6.97889 14.1467 6.18667C15.9656 5.39556 17.9167 5 20 5C22.0833 5 24.035 5.39556 25.855 6.18667C27.6739 6.97889 29.2572 8.04833 30.605 9.395C31.9517 10.7428 33.0211 12.3261 33.8133 14.145C34.6044 15.965 35 17.9167 35 20C35 22.0833 34.6044 24.0344 33.8133 25.8533C33.0211 27.6733 31.9517 29.2567 30.605 30.6033C29.2572 31.9511 27.6739 33.0211 25.855 33.8133C24.035 34.6044 22.0833 35 20 35Z"
          fill="white"
        />
        <path d="M16.5 26V14L26 20L16.5 26Z" fill="#323433" />
      </svg>
    </Icons>
  );
}
